import angular from 'angular';

angular.module('commonServices').factory('commOutSvc', ['$window', commOutSvc]);

function commOutSvc($window) {
  // This function exists so we can use the service either with an address in a string or with a reference to the addressList and the address
  var getAddressFromList = function(addressOrList, addressId) {
    if (typeof addressOrList === 'string' && typeof addressId === 'undefined') return addressOrList;

    var address = null;
    if (angular.isArray(addressOrList) && typeof addressId !== 'undefined') {
      for (var t = 0; t < addressOrList.length; t++) {
        if (addressOrList[t].id === addressId) {
          address = addressOrList[t];
          break;
        }
      }
      if (!address) {
        console.warn("CommOutSvc: Address wasn't found in the list!", addressId, addressOrList);
      }
    } else if (
      angular.isObject(addressOrList) &&
      typeof addressOrList.addressData !== 'undefined'
    ) {
      address = addressOrList;
    }

    if (address == null) return null;
    if (address.medium === 0 || address.medium === 5)
      return (
        address.postAddress.street1 +
        ' ' +
        address.postAddress.number +
        ',  ' +
        address.postAddress.zipCode +
        ' ' +
        address.postAddress.city +
        ', ' +
        address.postAddress.country
      );
    return address.addressData;
  };

  var formatHref = function(addressOrList, addressId, medium) {
    if (!addressOrList) return '';

    var data = getAddressFromList(addressOrList, addressId);
    if (!data) return '';

    switch (medium) {
      case 5:
      case 0:
        return 'http://maps.google.be/maps?q=' + data;
      case 1:
        return 'mailto:' + data;
      case 2:
      case 4:
        return 'tel:' + data.replace(/[^0-9+]/g, '');
      case 3:
      case 6:
      case 7:
      case 8:
      case 9:
      case 10:
      case 11:
      case 12:
      case 13:
        if (data.indexOf('http://') === -1 && data.indexOf('https://') === -1) {
          data = 'http://' + data;
        }
        return data;
      default:
        return '';
    }
  };

  return {
    formatHref: formatHref,
  };
}
